import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  rrTable: {
    zIndex: 5,
    justifyContent: "space-between",
    flexWrap: "nowrap"
  },
  rrTitle: {
    color: theme.palette.text.primary,
    fontSize: 14,
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    marginBottom: 8,
    lineHeight: 1
  },
  rrTableHeader: {
    color: "#444444",
    fontSize: 12,
    lineHeight: "normal",
    marginBottom: 4
  },
  rrTableCell: {
    color: "#444444",
    fontSize: 12,
    lineHeight: "normal"
  },
  ellipsisWrapper: {
    overflow: "hidden",
    marginRight: 4
  },
  ellipsis: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  }
}));
